(function(){
  var section = document.querySelector('[data-qbb-inside]');
  if (!section) return;
  var dataEl = document.querySelector('script[data-qbb-inside-data]');
  var items = [];
  try { items = JSON.parse(dataEl.textContent); } catch(e) {}
  var track = section.querySelector('[data-qbb-inside-track]');
  var emptyText = section.getAttribute('data-empty-text') || '';

  function esc(s){ return (s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function cardHtml(it){
    var img = it.image ? '<img src="' + it.image + '" alt="' + esc(it.title) + '" loading="lazy">' : '';
    return '<a class="qbb-inside-card" href="' + it.url + '" style="display:block">' +
      '<div class="qbb-inside-badge"><span>' + esc(it.title) + '</span></div>' +
      '<div class="qbb-inside-sub">' + esc(it.pieces) + '</div>' +
      '<div class="qbb-inside-img">' + img + '</div>' +
      (it.description ? '<div class="qbb-inside-desc">' + esc(it.description) + '</div>' : '') +
      '</a>';
  }

  function renderFor(index){
    var bundleNum = index + 1;
    var matches = items.filter(function(it){ return it.bundle === bundleNum; });
    if (!matches.length) {
      track.innerHTML = '<div class="qbb-inside-empty">' + esc(emptyText) + '</div>';
      return;
    }
    track.innerHTML = matches.map(cardHtml).join('');
  }

  document.addEventListener('qbb:bundle-changed', function(e){
    renderFor(e.detail.index);
  });

  var prevBtn = section.querySelector('[data-qbb-inside-prev]');
  var nextBtn = section.querySelector('[data-qbb-inside-next]');
  function scrollBy(dir){
    var card = track.querySelector('.qbb-inside-card');
    var w = card ? card.getBoundingClientRect().width + 18 : 250;
    track.scrollBy({ left: dir * w, behavior: 'smooth' });
  }
  if (prevBtn) prevBtn.addEventListener('click', function(){ scrollBy(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function(){ scrollBy(1); });

  renderFor(window.QBB ? (window.QBB.activeIndex || 0) : 0);
})();
